// src/config/menu.js
import {
    DashboardOutlined,
    UserOutlined,
    DropboxOutlined,
    UsergroupAddOutlined,
    UploadOutlined,
    CarOutlined,
    DribbbleOutlined,
    ExperimentOutlined,
    AppstoreAddOutlined,
    TagsOutlined,
    CloudUploadOutlined,
    BookOutlined,
    ReadOutlined,
} from '@ant-design/icons';

export const MenuList = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard', to: '/dashboard' },
    {
        key: 'manage orders',
        icon: <DropboxOutlined />,
        label: 'Manage Orders',
        to: '/manage-orders'
    },
    {
        key: 'orders',
        icon: <CarOutlined />,
        label: 'Manage Vehicle',
        to: '/manage-vehicle'
    },
    {
        key: 'drivers',
        icon: <DribbbleOutlined />,
        label: 'Manage Drivers',
        to: '/manage-drivers'
    },
    {
        key: 'Manage Services',
        icon: <ExperimentOutlined />,
        label: 'Manage Services',
        to: '/manage-services'
    },
    {
        key: 'Manage Addon Services',
        icon: <AppstoreAddOutlined />,
        label: 'Manage Addon Services',
        to: '/manage-sepcial-services'
    },
    {
        key: 'offers and coupon',
        icon: <TagsOutlined />,
        label: 'Coupon & Offers',
        to: '/coupon-offers'
    },
    {
        key: 'Uploads',
        icon: <CloudUploadOutlined />,
        label: 'Uploads',
        to: '/manage-uploads'
    },
   
     {
        key: 'page config',
        icon: <BookOutlined />,
        label: 'Page Builder',
        to: '/page-builder',
         
    },
     {
        key: 'seo',
        icon: <ReadOutlined />,
        label: 'Pre Build Pages',
        children: [
            // { key: 'Home page', label: 'Home Page', to: '/home-page-seo' },
            { key: 'configuration', label: 'Configuration', to: '/configuration' },
            { key: 'contact us page', label: 'Contact Us Page', to: '/contact-us-page-seo' },
            { key: 'Service page', label: 'Service Page', to: '/service-page-seo' },
            { key: 'Profile page', label: 'Profile Page', to: '/profile-page-seo' },
            { key: 'select car page', label: 'Car Selection Page', to: '/select-car-page-seo' },
        ]
    },
];